var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { attrs: { align: "center" } },
    [
      _c(
        "v-col",
        { attrs: { cols: "8" } },
        [
          _c("v-select", {
            attrs: {
              outlined: "",
              "hide-details": "",
              dense: "",
              "item-value": "id",
              "item-text": "title",
              multiple: "",
              "no-data-text": "Список пуст",
              items: _vm.entities,
              value: _vm.value,
              disabled: _vm.$apollo.queries.entities.loading,
              loading: _vm.$apollo.queries.entities.loading,
            },
            on: {
              click: function ($event) {
                return _vm.$apollo.queries.entities.refetch()
              },
              change: function ($event) {
                return _vm.$emit("input", $event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }